export default class EventUser {
  constructor(eventUser) {
    this.eventUser = eventUser;
  }

  isGroupMember(groupId) {
    if (this.getRole().roleLevel === 0) return true;

    if (
      this.getRole().roleLevel === 1 ||
      this.getRole().roleLevel === 2
    ) {
      return this.getGroups().some((group) => group === groupId);
    }

    return false;
  }

  getGroup() {
    return this.eventUser.role.eventGroup; // Returns the group ID
  }

  getGroups() {
    return [this.getGroup()]; // TODO: Add support for multiple groups
  }

  getRole() {
    return this.eventUser.role.eventRole;
  }

  hasRole(roleLevel) {
    const role = this.getRole();

    if (Array.isArray(roleLevel)) return roleLevel.includes(role.roleLevel);

    return roleLevel === role.roleLevel;
  }
}
